import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdateOpportunityStatusService {
  updateOpportunityStatus = new Subject();

  update() {
    this.updateOpportunityStatus.next(true);
  }
}
